import axios from 'axios';

const MIN_LOADER_TIME = 900 // millisecondi

const form = {
	updateFieldState: (field) => {
		if (field.value != '') {
			field.classList.add('not-empty')
		} else {
			field.classList.remove('not-empty')
		}
	},
	showResponse: (type) => {
		const popup = document.getElementById('form-response-popup')
		if (!popup) return

		popup.querySelector('.form-response-popup__message--success').hidden = type !== 'success'
		popup.querySelector('.form-response-popup__message--error').hidden = type !== 'error'
		popup.classList.add('is-active')
		document.querySelector('html, body').classList.add('noscroll')
	},
	hideResponse: () => {
		const popup = document.getElementById('form-response-popup')
		if (!popup) return

		popup.classList.remove('is-active')
		document.querySelector('html, body').classList.remove('noscroll')
	},
	closeFormPopup: () => {
		const activePopup = document.querySelector('.js-popup.is-active')
		if (!activePopup) return

		activePopup.classList.remove('is-active')
		document.querySelector('html, body').classList.remove('noscroll')
	},
	resetForm: (formToSubmit) => {
		formToSubmit.reset()
		formToSubmit.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]), textarea, select').forEach(field => {
			form.updateFieldState(field)
		})
	},
	initResponsePopup: () => {
		const popup = document.getElementById('form-response-popup')
		if (!popup) return

		popup.querySelectorAll('.js-close-form-response').forEach(btn => {
			btn.addEventListener('click', () => form.hideResponse())
		})

		popup.addEventListener('click', (e) => {
			if (e.target === popup) form.hideResponse()
		})
	},
	// La box "motivo" compare solo se si sceglie "Altro", ed e' obbligatoria solo quando e' visibile.
	initArgumentOther: () => {
		document.querySelectorAll('form').forEach(formEl => {
			const select = formEl.querySelector('[name="form_submission[argument]"]')
			const wrapper = formEl.querySelector('.js-argument-other')
			if (!select || !wrapper) return

			const field = wrapper.querySelector('textarea')
			const sync = () => {
				const option = select.options[select.selectedIndex]
				const isOther = !!option && option.dataset.argument === 'other'
				wrapper.classList.toggle('d-none', !isOther)
				field.required = isOther
				if (!isOther && field.value !== '') {
					field.value = ''
					form.updateFieldState(field)
				}
			}
			select.addEventListener('change', sync)
			sync()
		})
	},
	init: () => {
		form.initResponsePopup()
		form.initArgumentOther()

		let inputs = document.querySelectorAll('form input:not([type="checkbox"]):not([type="radio"]), form textarea')
		inputs.forEach(i => {
			form.updateFieldState(i)
			i.addEventListener('input', () => form.updateFieldState(i))
			i.addEventListener('change', () => form.updateFieldState(i))
		})
		let select = document.querySelectorAll('form select')
		select.forEach(s => {
			form.updateFieldState(s)
			s.addEventListener('change', () => form.updateFieldState(s))
		})
		let sendBtn = document.querySelectorAll('.js-send-message')
		sendBtn.forEach(i => {
			i.addEventListener('click', (e) => {
				e.preventDefault()
				let formToSubmit = e.currentTarget.closest('form')
				if (!formToSubmit.checkValidity()) {
					formToSubmit.reportValidity()
					return
				}
				e.currentTarget.classList.add('disabled', 'is-loading')
				form.send_message(formToSubmit, e.currentTarget)
			})
		})
	},
	stopLoading: (submitBtn) => {
		submitBtn.classList.remove('disabled', 'is-loading')
	},
	send_message: (formToSubmit, submitBtn) => {
		if (!formToSubmit.action) {
			form.stopLoading(submitBtn)
			form.showResponse('error')
			return
		}

		// Il server risponde in pochi decimi di secondo: teniamo il loader
		// visibile almeno MIN_LOADER_TIME, altrimenti il popup appare di scatto.
		const startedAt = Date.now()
		const finish = (showResult) => {
			const wait = Math.max(0, MIN_LOADER_TIME - (Date.now() - startedAt))
			window.setTimeout(() => {
				form.stopLoading(submitBtn)
				showResult()
			}, wait)
		}

		let data = new FormData(formToSubmit)
		axios({
			url: formToSubmit.action,
			method: formToSubmit.method,
			headers: {
				'Accept': 'application/json'
			},
			data: data
		}).then((response) => {
			if (response.status >= 200 && response.status < 300) {
				finish(() => {
					form.closeFormPopup()
					form.resetForm(formToSubmit)
					form.showResponse('success')
				})
			} else {
				finish(() => form.showResponse('error'))
			}
		}).catch(() => {
			finish(() => form.showResponse('error'))
		})
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('form')) {
		form.init()
	}
})
